import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import { labelStyles } from "views/pages/manage/masters/studentFinancials/chargeModifications/constants";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import { hardcodeDropdown } from "../services";

const FilterForm = ({
    closePopup,
    filterForm,
    setFilterForm,
    filterCount,
    setFilterCount,
    applyFilterHandler,
    filterFormHandler,
}) => {

    const resetFilterForm = () => {
        setFilterCount(0);
        setFilterForm({});
        applyFilterHandler({});
        closePopup();
    };



    const handleApplyFilter = () => {
        let fCount = getFilterCount({ ...filterForm });
        setFilterCount(fCount);
        applyFilterHandler(filterForm);
        closePopup();
    };


    return (
        <Card
            className="mb-0 regular-body label-color"
            style={{ width: "330px", borderRadius: "12px" }}
        >
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                </div>

                <div className="d-flex flex-column gap-md">

                    <AAutoComplete
                        label="Event"
                        currentValue={filterForm?.event}
                        items={hardcodeDropdown?.events}
                        handleChange={(value) => filterFormHandler("event", value)}
                        isMulti={false}
                    />

                    <div style={labelStyles}>Filter By</div>
                    <div className={"d-flex flex justify-content-between"} style={{ columnGap: '10px' }}>
                        <CustomDatePickerV2
                            placeHolder="From"
                            maxDate={moment(new Date())}
                            value={filterForm?.dateFrom}
                            width={"18px"}
                            handler={(index, date, keyName) => {
                                filterFormHandler("dateFrom", moment(date).startOf('day'));
                                filterFormHandler("dateTo", moment(new Date()).endOf('day'));
                            }}
                        />
                        <CustomDatePickerV2
                            placeHolder="To"
                            width={"18px"}
                            maxDate={moment(new Date())}
                            value={filterForm?.dateTo}
                            handler={(index, date, keyName) => {
                                filterFormHandler("dateTo", moment(date).endOf('day'));
                            }}
                        />
                    </div>
                </div>
                <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                    <AButton
                        variant="primary_filled"
                        className="button_remove_left_margin"
                        onClick={() => {
                            handleApplyFilter();
                        }}
                        disabled={getFilterCount({ ...filterForm }) == 0}
                    >
                        Apply filter
                    </AButton>

                    {filterCount > 0 && (
                        <AButton
                            variant="outline"
                            className="button_remove_left_margin"
                            updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                            onClick={resetFilterForm}
                        >
                            Remove filter
                        </AButton>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};
export default FilterForm;
